import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const PAGE_NAMES = {
  '/': 'Home',
  '/about': 'About',
  '/gallery': 'Gallery',
  '/exhibitions': 'Exhibitions',
  '/press': 'Press & Media',
  '/contact': 'Contact',
  '/testimonials': 'Reviews',
  '/commissions': 'Custom Paintings',
  '/cart': 'Cart',
  '/checkout': 'Checkout',
};

const PageTracker = () => {
  const location = useLocation();
  const lastPath = useRef('');

  useEffect(() => {
    const path = location.pathname;
    if (path === lastPath.current) return;
    if (path.startsWith('/admin')) return;
    lastPath.current = path;

    const page = PAGE_NAMES[path] || path;
    axios.post(`${API}/analytics/track`, {
      page,
      referrer: document.referrer || '',
    }).catch(() => {});
  }, [location.pathname]);

  return null;
};

export default PageTracker;

export function trackArtworkView(artworkId, artworkTitle) {
  axios.post(`${API}/analytics/track`, {
    page: 'Artwork View',
    artwork_id: artworkId,
    artwork_title: artworkTitle || '',
    referrer: document.referrer || '',
  }).catch(() => {});
}
